import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

const bps = DtvTheme.breakpoints;

export const channelColWidthStyle = {
  flex: 1,
  minWidth: {
    xs: "84px",
    sm: "170px",
    md: "250px"
  },
  width: "100%"
};

export const channelLabelColWidthStyle = {
  minWidth: {
    xs: "102px",
    sm: "170px",
    md: "250px"
  },
  width: {
    xs: "102px",
    sm: "170px",
    md: "250px"
  },
  flex: "none",
  boxSizing: "border-box",
  padding: "0 8px"
};

export const pkgStyles = {
  pkgTableHead: {
    width: "100%",
    zIndex: 500,
    position: "sticky",
    top: '0px'
  },
  pkgNameTd: {
    border: "none",
    // padding: "0px 4px",
    display: "flex",
    alignItems: "end",
    flexDirection: "row",
    height: "fit-content",
    backgroundColor: colorPalette?.neutral_white.main,
    [bps.up(bps.values.md)]: {
      borderRadius: "8px 8px 0px 0px"
    },
    [bps.down(bps.values.md)]: {
      borderRadius: "0px 0px 8px 8px"
    }
  },
  pkgNameDiv: {
    padding: "11px 3px 15px 3px",
    width: "100%",
    alignContent: "center",
    [bps.up(bps.values.md)]: {
      borderRadius: "8px 8px 0px 0px",
      justifyContent: "center",
      display: "flex"
    },
    [bps.down(bps.values.md)]: {
      borderRadius: "0px 0px 8px 8px",
      writingMode: "vertical-rl !important",
      textOrientation: "mixed !important",
      transform: "rotate(180deg) !important",
      height: "180px",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center"
    }
  },
  pkgNameText: {
    textAlign: "left",
    fontWeight: "600 !important",
    whiteSpace: "nowrap",
    fontSize: "20px !important"
  },
  myfreeDtvDescriptionContainer: {
    display: "flex",
    width: "100%",
    backgroundColor: colorPalette.neutral[100],
    padding: "12px 8px",
    color: colorPalette.jet.main,
    textAlign: "center",
    justifyContent: "center"
  },
  myfreeDtvDescriptionText: {
    fontSize: "16px !important",
    fontWeight: 400,
    lineHeight: "130%"
  },
  channelRow: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    margin: "0",
    background: "transparent",
    border: "none",
    borderBottom: `1px solid ${colorPalette.neutral[300]}`
  },
  channelNameContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: "20px 8px !important",
    border: "none",
    color: colorPalette.jet.main,
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    borderRight: `1px solid ${colorPalette.neutral[300]}`
  },
  channelNameData: {
    textAlign: "center",
    alignItems: 'center'
  },
  channelNameMyfreeDtv: {
    textAlign: "left",
    alignItems: 'flex-start',
    width: "100% !important"
  },
  subscriptionLabel: {
    display: "block",
    position: "relative",
    width: "100%",
    padding: "4px 0px",
    backgroundColor: colorPalette.blue[800],
    fontSize: "12px !important",
    fontWeight: 500,
    color: "white.main",
    textAlign: "center",
    zIndex: 20

  },
  localRsnLabel: {
    display: "block",
    position: "relative",
    maxWidth: "80px",
    maxHeight: "80px",
    borderRadius: "4px",
    m: "0px auto 7px auto",
    p: "5px",
    backgroundColor: colorPalette.gray[300],
    fontSize: "12px !important",
    fontWeight: 500,
    color: "white.main",
    textAlign: "center",
    zIndex: 20
  },
  channelIndicatorBox: {
    display: "flex",
    flexDirection: "column",
    padding: "8px 0px",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center"
  },
  priceRow: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    margin: "0",
    background: colorPalette.neutral[200],
    border: "none"
  },
  priceLabelContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: {
      xs: "20px 0px 0px 20px",
      sm: "25px 20px"
    },
    border: "none",
    color: colorPalette.jet.main,
    justifyContent: {
      xs: "flex-start",
      sm: "left"
    },
    textAlign: {
      xs: "left",
      sm: "left"
    },
    alignItems: {
      xs: "flex-start",
      sm: "left"
    },
    gap: "2px"
  },
  pricesBox: {
    display: "flex",
    flexDirection: "column",
    padding: {
      xs: "25px 0px 25px 10px",
      sm: "25px 0px 25px 20px"
    },
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textAlign: "left"
  },
  priceLabelMobileText: {
    fontSize: "14px",
    fontWeight: "500 !important",
    lineHeight: "130%",
    textWrap: "wrap",
    textAlign: "left",
    color: colorPalette.blue[900],
    [bps.up(bps.values.sm)]: {
      display: "none"
    }
  },
  priceLabelText: {
    fontWeight: 500,
    fontSize: "14px !important",
    lineHeight: "130%",
    textWrap: "wrap",
    color: colorPalette.blue[900],
    textAlign: "left",
    [bps.down(bps.values.sm)]: {
      display: 'none'
    }
  },
  fixedColumn: {
    position: "sticky",
    left: 0,
    zIndex: 500,
    backgroundColor: colorPalette.neutral_white.main
  },
  packagesHeaderRow: {
    display: "flex",
    alignItems: "stretch",
    backgroundColor: "#FFFFFF",
    gap: "6px"
  },
  headerCellHeight: {
    height: {
      xs: "264px",
      sm: "190px"
    },
    minHeight: {
      sm: "165px",
      md: "180px"
    }
  },
  columnWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  columnTitleBar: {
    height: {
      xs: '18px',
      sm: '20px'
    },
    width: '100%',
    background: '#0B1C2D',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px 6px 0 0',
    pb: { xs: 0 }
  },
  packageNameArea: {
    flex: { sm: 1 },
    height: { xs: '138px' },
    minHeight: { sm: '114px' },
    width: '100%',
    overflow: {
      xs: 'hidden',
      sm: 'hidden'
    },
    display: 'flex',
    alignItems: {
      xs: 'flex-end',
      sm: 'flex-start'
    },
    justifyContent: {
      xs: 'center',
      sm: 'flex-start'
    },
    pt: "18px",
    pb: 0,
    pl: { sm: '16px' }
  },
  buttonArea: {
    mb: '5px',
    display: 'flex',
    alignItems: 'center',
    gap: {
      xs: "6px",
      sm: "7px"
    },
    width: "100%",
    paddingBottom: {
      xs: "10px",
      sm: "16px"
    }
  },
  drawerContainer: {
    width: '100%',
    borderRadius: '6px',
    pt: 2,
    mb: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    background: "#D8E7F9",
    justifyContent: 'space-between',
    mb: 2
  },
  orSeparator: {
    display: 'flex',
    alignItems: 'center',
    my: 2
  },
  orSeparatorLine: {
    flex: 1,
    height: '1px',
    background: '#B0B8C1'
  },
  orSeparatorText: {
    mx: 2,
    color: '#6B7683',
    fontWeight: 600,
    letterSpacing: 1
  },
  compareLabelText: {
    writingMode: {
      xs: 'vertical-rl',
      sm: 'horizontal-tb'
    },
    transform: {
      xs: 'rotate(180deg)',
      sm: 'none'
    },
    textAlign: 'flex-start',
    whiteSpace: 'pre-line',
    lineHeight: 1.2,
    minWidth: "40px",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: "text.secondary",
    mt: 0
  }
}
